import React from 'react';

const MAKS_FILER = 5;
const TILLADTE_TYPER = ['.pdf','.docx','.doc','.xlsx','.xls','.png','.jpg','.jpeg'];

function filtype_ok(navn) {
  const ext = '.' + navn.split('.').pop().toLowerCase();
  return TILLADTE_TYPER.includes(ext);
}

export default function UploadPortal({ token }) {
  const [info, setInfo] = React.useState(null);
  const [fejl, setFejl] = React.useState(null);
  const [filer, setFiler] = React.useState([]);
  const [sender, setSender] = React.useState(false);
  const [sendt, setSendt] = React.useState(false);
  const [drag_over, setDragOver] = React.useState(false);

  React.useEffect(() => {
    fetch(`/api/upload-portal/token/${token}/info`)
      .then(r => r.ok ? r.json() : r.json().then(d => { throw new Error(d.fejl || 'Link er ugyldigt'); }))
      .then(d => setInfo(d))
      .catch(e => setFejl(e.message));
  }, [token]);

  function tilfoej_filer(nye_filer) {
    const filtre = Array.from(nye_filer).filter(f => {
      if (!filtype_ok(f.name)) { alert(`Filtypen ${f.name.split('.').pop()} er ikke tilladt.`); return false; }
      if (f.size > 20 * 1024 * 1024) { alert(`${f.name} er for stor (maks 20 MB).`); return false; }
      return true;
    });
    setFiler(prev => {
      const samlet = [...prev, ...filtre.map(f => ({ fil: f, navn: f.name.replace(/\.[^.]+$/, ''), noter: '' }))];
      return samlet.slice(0, MAKS_FILER);
    });
  }

  function opdater_felt(idx, felt, val) {
    setFiler(prev => prev.map((f, i) => i === idx ? { ...f, [felt]: val } : f));
  }

  function fjern(idx) {
    setFiler(prev => prev.filter((_, i) => i !== idx));
  }

  async function send() {
    if (!filer.length) return;
    setSender(true);
    try {
      const body = new FormData();
      filer.forEach(({ fil, navn, noter }) => {
        body.append('files', fil);
        body.append('navn', navn || fil.name);
        body.append('noter', noter || '');
      });
      const r = await fetch(`/api/upload-portal/token/${token}/upload`, { method: 'POST', body });
      if (!r.ok) {
        const d = await r.json();
        throw new Error(d.fejl || 'Upload fejlede');
      }
      setSendt(true);
    } catch (e) {
      alert('Noget gik galt: ' + e.message);
    } finally {
      setSender(false);
    }
  }

  const stil = {
    body: { fontFamily: "'Inter', system-ui, sans-serif", background: '#f8fafc', minHeight: '100vh', margin: 0, padding: 0 },
    wrap: { maxWidth: 620, margin: '0 auto', padding: '40px 20px' },
    logo: { fontSize: 22, fontWeight: 800, color: '#0a0e2e', marginBottom: 8 },
    subtitle: { fontSize: 13, color: '#64748b', marginBottom: 32 },
    box: { background: '#fff', borderRadius: 16, padding: '28px 24px', boxShadow: '0 2px 16px rgba(0,0,0,0.06)', marginBottom: 20 },
    h2: { fontSize: 17, fontWeight: 700, color: '#0f172a', marginBottom: 8, marginTop: 0 },
    besked: { background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 10, padding: '12px 16px', fontSize: 14, color: '#0369a1', marginBottom: 20 },
    drop: { border: '2px dashed', borderColor: drag_over ? '#0ea5e9' : '#cbd5e1', borderRadius: 12, padding: '36px 20px', textAlign: 'center', cursor: 'pointer', background: drag_over ? '#f0f9ff' : '#f8fafc', transition: 'all 0.2s', marginBottom: 16 },
    dropTekst: { fontSize: 14, color: '#64748b', marginBottom: 12 },
    knap: { display: 'inline-block', background: '#0ea5e9', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 20px', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
    filKort: { background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: '14px 16px', marginBottom: 12 },
    label: { fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 4 },
    input: { width: '100%', border: '1px solid #e2e8f0', borderRadius: 7, padding: '8px 10px', fontSize: 13, color: '#1e293b', background: '#fff', boxSizing: 'border-box' },
    sendKnap: { background: '#0ea5e9', color: '#fff', border: 'none', borderRadius: 10, padding: '14px 28px', fontSize: 15, fontWeight: 700, cursor: sender ? 'default' : 'pointer', opacity: sender ? 0.7 : 1, width: '100%' },
    succes: { textAlign: 'center', padding: '40px 20px' },
    succesTjek: { fontSize: 64, marginBottom: 16 },
    succesTitel: { fontSize: 22, fontWeight: 800, color: '#0f172a', marginBottom: 8 },
    succesTekst: { fontSize: 14, color: '#64748b' },
    fejlBox: { background: '#fff1f2', border: '1px solid #fecdd3', borderRadius: 12, padding: '24px', textAlign: 'center' },
  };

  // Skriv globale styles inline
  React.useEffect(() => {
    document.body.style.background = '#f8fafc';
    document.body.style.margin = '0';
    return () => { document.body.style.background = ''; document.body.style.margin = ''; };
  }, []);

  if (fejl) return (
    <div style={stil.wrap}>
      <div style={stil.logo}>SkilsmisseVejen</div>
      <div style={stil.fejlBox}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
        <div style={{ fontSize: 16, fontWeight: 700, color: '#be123c', marginBottom: 8 }}>Link er ikke gyldigt</div>
        <div style={{ fontSize: 14, color: '#64748b' }}>{fejl}</div>
        <div style={{ fontSize: 13, color: '#94a3b8', marginTop: 12 }}>Kontakt din sagsbehandler for et nyt link.</div>
      </div>
    </div>
  );

  if (!info) return (
    <div style={{ ...stil.wrap, textAlign: 'center', paddingTop: 80 }}>
      <div style={{ fontSize: 14, color: '#64748b' }}>Henter information…</div>
    </div>
  );

  if (sendt) return (
    <div style={stil.wrap}>
      <div style={stil.logo}>SkilsmisseVejen</div>
      <div style={{ ...stil.box, ...stil.succes }}>
        <div style={stil.succesTjek}>✅</div>
        <div style={stil.succesTitel}>Dine dokumenter er modtaget!</div>
        <div style={stil.succesTekst}>Din sagsbehandler vil gennemgå dem og kontakte dig ved behov.</div>
      </div>
    </div>
  );

  return (
    <div style={stil.wrap}>
      <div style={stil.logo}>SkilsmisseVejen</div>
      <div style={stil.subtitle}>Sikker dokumentupload</div>

      {info.besked && <div style={stil.besked}>💬 {info.besked}</div>}

      {info.frist && (
        <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 16 }}>
          Link udløber: {new Date(info.frist).toLocaleDateString('da-DK', { dateStyle: 'long' })}
        </div>
      )}

      <div style={stil.box}>
        <h2 style={stil.h2}>Upload dine dokumenter</h2>
        <p style={{ fontSize: 13, color: '#64748b', marginTop: 0, marginBottom: 16 }}>
          Du kan uploade op til {MAKS_FILER} filer ad gangen.<br />
          Tilladte typer: PDF, Word, Excel, billeder. Maks 20 MB pr. fil.
        </p>

        {/* Drop-zone */}
        <div
          style={stil.drop}
          onDragOver={e => { e.preventDefault(); setDragOver(true); }}
          onDragLeave={() => setDragOver(false)}
          onDrop={e => { e.preventDefault(); setDragOver(false); tilfoej_filer(e.dataTransfer.files); }}
          onClick={() => document.getElementById('up-input').click()}
        >
          <div style={stil.dropTekst}>Træk filer hertil, eller</div>
          <span style={stil.knap}>Vælg filer</span>
          <input
            id="up-input"
            type="file"
            multiple
            accept=".pdf,.docx,.doc,.xlsx,.xls,.png,.jpg,.jpeg"
            style={{ display: 'none' }}
            onChange={e => tilfoej_filer(e.target.files)}
          />
        </div>

        {/* Per-fil-inputs */}
        {filer.map(({ fil, navn, noter }, idx) => (
          <div key={idx} style={stil.filKort}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: '#0f172a' }}>
                📄 {fil.name} ({(fil.size / 1024 / 1024).toFixed(1)} MB)
              </span>
              <button onClick={() => fjern(idx)} style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', fontSize: 18, lineHeight: 1 }}>×</button>
            </div>
            <label style={stil.label}>Navn på filen</label>
            <input
              style={{ ...stil.input, marginBottom: 10 }}
              value={navn}
              onChange={e => opdater_felt(idx, 'navn', e.target.value)}
              placeholder="Fx: Bopælsattest, Skatteoplysninger…"
            />
            <label style={stil.label}>Beskrivelse (valgfrit)</label>
            <textarea
              style={{ ...stil.input, minHeight: 60, resize: 'vertical' }}
              value={noter}
              onChange={e => opdater_felt(idx, 'noter', e.target.value)}
              placeholder="Evt. kort beskrivelse af dokumentet"
            />
          </div>
        ))}

        {filer.length > 0 && (
          <button style={stil.sendKnap} onClick={send} disabled={sender}>
            {sender ? 'Sender…' : `Send ${filer.length} dokument${filer.length !== 1 ? 'er' : ''}`}
          </button>
        )}
      </div>
    </div>
  );
}
